import { MAX_TTL_DAYS, MIN_TTL_SECONDS } from '../constants';

/** Parse custom TTL like 5m / 2h / 1d into total seconds. Returns null if invalid. */
export function parseCustomTtlSeconds(value) {
  const trimmed = value.trim();
  const match = trimmed.match(/^(\d+)([smhd])$/);
  if (!match) return null;

  const amount = parseInt(match[1], 10);
  const unit = match[2];
  if (!amount || amount <= 0) return null;

  switch (unit) {
    case 's': return amount;
    case 'm': return amount * 60;
    case 'h': return amount * 60 * 60;
    case 'd': return amount * 60 * 60 * 24;
    default: return null;
  }
}

export function formatRemainingLabel(createdAtMs, ttlValue) {
  if (!createdAtMs) return '';
  const seconds = parseCustomTtlSeconds(ttlValue);
  if (!seconds) return '';
  const remainingMs = createdAtMs + seconds * 1000 - Date.now();
  if (remainingMs <= 0) return 'Expired';

  const totalSeconds = Math.floor(remainingMs / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  if (days > 0) return `${days}d ${hours}h left`;
  if (hours > 0) return `${hours}h ${minutes}m left`;
  if (minutes > 0) return `${minutes}m left`;
  return `${secs}s left`;
}

export function validateCustomTtl(value) {
  if (!value.trim() || !value.replace(/[^0-9]/g, '')) {
    return { valid: false, message: 'Enter how long the link should stay valid.' };
  }

  const seconds = parseCustomTtlSeconds(value.trim());
  if (seconds === null) {
    return { valid: false, message: 'Use a duration like 30s, 5m, 2h, or 1d.' };
  }

  if (seconds < MIN_TTL_SECONDS) {
    return { valid: false, message: 'Links must stay valid for at least 1 minute.' };
  }

  const maxSeconds = MAX_TTL_DAYS * 24 * 60 * 60;
  if (seconds > maxSeconds) {
    return { valid: false, message: `Links can stay valid for up to ${MAX_TTL_DAYS} days.` };
  }

  return { valid: true, message: '' };
}
